(function ($) {
    'use strict';
    $.fn.characterLimit = function () {
        var $self = $(this);
        var $textarea = $self.find('textarea');
        var $helpBlock = $self.find('.help-block');
        var $formGroup = $self.find('.form-group');
        var limitMax;
        var limitMin;
        var inputValueLength;
        var errorClass = 'has-error';
        var noErrorClass = 'no-error';

        var calculateValueLength = function (number) {
            var messageMaxValue = 'Превышено количество символов: ' + number +' при максимуме в ' + limitMax;
            var messageMinValue = 'Недостаточное количество символов: ' + number +' при минимуме в ' + limitMin;
            var messageNormal = 'Количество символов: ' + number + ' из ' + limitMax + ' (минимум: ' + limitMin + ')';

            $formGroup.removeClass(noErrorClass);
            $formGroup.removeClass(errorClass);

            if ( number > limitMin && number < limitMax) {
                    $formGroup.addClass(noErrorClass);
                    creatingMessage(messageNormal);
                    return;
            }

            $formGroup.addClass(errorClass);

            if (number > limitMax) {
                    creatingMessage(messageMaxValue);
                    return;
            }
            creatingMessage(messageMinValue);
        };

        var creatingMessage = function (message) {
            $helpBlock.text(message);
        };

        var init = function () {
            if($textarea) {
                $textarea.on('input', function () {
                    limitMax = $textarea.attr('data-max-length');
                    limitMin = $textarea.attr('data-min-length');
                    inputValueLength = $(this).val().length;
                    calculateValueLength(inputValueLength);
                });
            }
        };

        init();
    };
    $('.js-character-limit').each(function () {
        $(this).data('characterLimit', $(this).characterLimit());
    });
})(jQuery);
